"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetPartner = exports.isCurrentPartnerLocked = exports.getPartners = exports.getCurrentPartnerStatus = exports.getCurrentPartnerName = exports.getCurrentPartnerId = exports.getCurrentPartnerFacematch = exports.getCurrentPartner = exports.arePartnersLoadedSelector = void 0;
var _reselect = require("reselect");
var _chatSelector = require("./chatSelector");
var _types = require("../actions/types");
var _getPartners = function _getPartners(_ref) {
  var partners = _ref.partners;
  return partners;
};
var _getPartnersKeys = function _getPartnersKeys(_ref2) {
  var partners = _ref2.partners;
  return Object.keys(partners);
};
var _getRoomnameFromProps = function _getRoomnameFromProps(_, _ref3) {
  var chat = _ref3.chat;
  return chat.roomname;
};
var arePartnersLoadedSelector = exports.arePartnersLoadedSelector = (0, _reselect.createSelector)(_getPartnersKeys, function (partners) {
  return partners.length > 0;
});
var makeGetPartner = exports.makeGetPartner = function makeGetPartner() {
  return (0, _reselect.createSelector)([_getPartners, _getRoomnameFromProps], function (partners, roomname) {
    return partners[roomname];
  });
};
var getCurrentPartner = exports.getCurrentPartner = (0, _reselect.createSelector)([_chatSelector.getCurrentChat, _getPartners], function (currentChat, partners) {
  return partners[currentChat.roomname] || {};
});
var getCurrentPartnerStatus = exports.getCurrentPartnerStatus = (0, _reselect.createSelector)(getCurrentPartner, function (_ref4) {
  var status = _ref4.status;
  return status;
});
var getCurrentPartnerId = exports.getCurrentPartnerId = (0, _reselect.createSelector)(getCurrentPartner, function (_ref5) {
  var id = _ref5.id;
  return id;
});
var getCurrentPartnerFacematch = exports.getCurrentPartnerFacematch = (0, _reselect.createSelector)(getCurrentPartner, function (_ref6) {
  var facematch = _ref6.facematch;
  return facematch;
});
var getCurrentPartnerName = exports.getCurrentPartnerName = (0, _reselect.createSelector)(getCurrentPartner, function (_ref7) {
  var name = _ref7.name;
  return name;
});
var getPartners = exports.getPartners = (0, _reselect.createSelector)(_getPartners, function (partners) {
  return partners;
});
var isCurrentPartnerLocked = exports.isCurrentPartnerLocked = (0, _reselect.createSelector)(getCurrentPartner, function (_ref8) {
  var status = _ref8.status;
  var BLOCKED = _types.PARTNERS_STATUS.BLOCKED,
    DENOUNCED = _types.PARTNERS_STATUS.DENOUNCED;
  return [BLOCKED, DENOUNCED].includes(status);
});